export const SET_MEETING_COMMAND = 'SetMeetingCommand';
export const CREATE_MEETING_COMMAND = 'CreateMeetingCommand';
export const MEETING_CREATED_EVENT = 'MeetingCreatedEvent';
